import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import { requestDeletePassengers } from '../../actions/passengers'
import { resetPassengersToBeDeleted } from '../../actions/deletePassengers'
import { closePassengersToBeDeletedConfirmation } from '../../actions/modals'

import DeletePassengersOverview from '../../components/DeletePassengersOverview'

interface DeletePassengersOverviewPropsInterface {
  flightId: string
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: DeletePassengersOverviewPropsInterface
) => {
  const isLoading =
    state.requests.isValidatingPassengersBeforeRemoving ||
    state.requests.isRemovingPassengers

  const passengersToBeDeleted = state.passengersToBeDeleted.allIds.map(
    (passengerId: string) => state.passengersToBeDeleted.byId[passengerId]
  )

  const getUniqueIds = (allPassengerIds: string[], passengerId: string) =>
    allPassengerIds.includes(passengerId)
      ? allPassengerIds
      : [...allPassengerIds, passengerId]

  const passengerIdsToBeDeleted = state.passengersToBeDeleted.passengersSelectedForDeletion
    .filter(
      (passengerId: string) =>
        !state.passengers.allIds.includes(passengerId) ||
        state.passengersToBeDeleted.allIds.includes(passengerId)
    )
    .reduce(getUniqueIds, [])

  return {
    isOpen: state.modals.isPassengersToBeDeletedModalOpen,
    isLoading,
    flightId: props.flightId,
    passengersToBeDeleted,
    passengerIdsToBeDeleted,
    deleteAllPaxFromSingleFlight:
      state.requests.deletePassengersFromSingleFlight,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleConfirmDelete: (passengerIds: string[], flightId: string) => {
    dispatch(requestDeletePassengers(passengerIds, flightId))
  },
  handleCancelDelete: () => {
    dispatch(resetPassengersToBeDeleted())
    dispatch(closePassengersToBeDeletedConfirmation())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePassengersOverview)
